import React, {
    useCallback, useEffect, useMemo, useContext
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react'
import { Icon } from '@jutro/components';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { Link } from '@jutro/router';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import styles from './InternalClassificationofOperationsComponent.module.scss';
import metadata from './InternalClassificationofOperationsComponent.metadata.json5';

function InternalClassificationofOperationsComponent(props) {

    const {
        data: InternalClassificationofOperationsVM,
        updateWizardData,
        submissionVM,
        InternalClassificationofOperationsPath,
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();

    const addInternalClassificationofOperations = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            InternalClassificationofOperationsVM.value = InternalClassificationofOperationsVM.value || []

            const { _xCenter, _dtoName } = InternalClassificationofOperationsVM;

            const InternalClassificationofOperationsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            InternalClassificationofOperationsObjVM.isValidationReq.value = true

            InternalClassificationofOperationsVM.pushElement(
                InternalClassificationofOperationsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, InternalClassificationofOperationsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            InternalClassificationofOperationsVM.value.splice(index, 1);
            _.set(submissionVM.value, InternalClassificationofOperationsPath, InternalClassificationofOperationsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, InternalClassificationofOperationsPath, InternalClassificationofOperationsVM?.value]
    );

    const handleChangeCategory = async (speOpe, changedPath, index) => {
        _.set(InternalClassificationofOperationsVM, `value[${index}].groFie`, undefined);
        _.set(InternalClassificationofOperationsVM, `value[${index}].speOpeFie`, undefined);
        _.set(InternalClassificationofOperationsVM, `value[${index}].risClaFie`, undefined);
        handleValueChange();
    }


    const handleChangeGrouping = async (speOpe, changedPath, index) => {
        _.set(InternalClassificationofOperationsVM, `value[${index}].speOpeFie`, undefined);
        _.set(InternalClassificationofOperationsVM, `value[${index}].risClaFie`, undefined);
        handleValueChange();
    }


    const handleChangeSpecificOpretaions = async (speOpe, index) => {
        const riskClass = await LoadSaveService.getRiskClassification(speOpe, authHeader);

        _.set(InternalClassificationofOperationsVM?.value[index], 'risClaFie', riskClass);
        handleValueChange();
    }

    const ifOtherVisible = (index) => {
        const speOpeFieValue = _.get(InternalClassificationofOperationsVM, `value[${index}].speOpeFie`);

        return speOpeFieValue === 'OthEntRec' || speOpeFieValue === 'OthHolComp' || speOpeFieValue === 'OthLen' || speOpeFieValue === 'OthLogi'
            || speOpeFieValue === 'OthMan' || speOpeFieValue === 'OthRet' || speOpeFieValue === 'OthTran'
    }


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'catFie') {
                const value = (item && item.catFie) ? item.catFie : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = InternalClassificationofOperationsVM.length > 0 && InternalClassificationofOperationsVM.children[index].catFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? InternalClassificationofOperationsVM.children[index].catFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.catFie = val;
                            handleChangeCategory(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'groFie') {
                const value = (item && item.groFie) ? item.groFie : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = InternalClassificationofOperationsVM.length > 0 && InternalClassificationofOperationsVM.children[index].groFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? InternalClassificationofOperationsVM.children[index].groFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.groFie = val;
                            handleChangeGrouping(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'speOpeFie') {
                const value = (item && item.speOpeFie) ? item.speOpeFie : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = InternalClassificationofOperationsVM.length > 0 && InternalClassificationofOperationsVM.children[index].speOpeFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? InternalClassificationofOperationsVM.children[index].speOpeFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.speOpeFie = val;
                            handleChangeSpecificOpretaions(val, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'risClaFie') {
                const value = (item && item.risClaFie) ? item.risClaFie : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = InternalClassificationofOperationsVM.length > 0 && InternalClassificationofOperationsVM.children[index].risClaFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? InternalClassificationofOperationsVM.children[index].risClaFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        readOnly
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'ifOthexpFie') {
                const value = item.ifOthexpFie ? item.ifOthexpFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.ifOthexpFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        visible={ifOtherVisible(index)}
                    />
                );
            }
        }, [handleValueChange, translator, InternalClassificationofOperationsVM?.value])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`InternalClassificationofOperationsTable`]: {
            data: InternalClassificationofOperationsVM.value,
        }

    }), [InternalClassificationofOperationsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addInternalClassificationofOperations,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            InternalClassificationofOperationsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [InternalClassificationofOperationsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={InternalClassificationofOperationsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

InternalClassificationofOperationsComponent.propTypes = wizardProps;
export default withRouter(InternalClassificationofOperationsComponent);
